/* eslint-disable @typescript-eslint/no-unused-vars */

import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import { AssetsResponse } from '../entities/assets-v2/assets-response';
import { axiosInstance } from "../axios-instance";

class Assets {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getByTelematicsAssetId(telematicsAssetId: string): Promise<AxiosResponse<AssetsResponse[]>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<AssetsResponse[]>(`${this.baseUrl}/telematicsAssetIds/${telematicsAssetId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  getByAssetSerialNumber(assetSerialNumber: string): Promise<AxiosResponse<AssetsResponse[]>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<AssetsResponse[]>(`${this.baseUrl}/assetSerialNumbers/${assetSerialNumber}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default Assets;
